export function BpmnCustomContextPad(config, contextPad, create, elementFactory, injector, translate) {
  this.create = create
  this.elementFactory = elementFactory
  this.translate = translate

  if (config.autoPlace !== false) {
    this.autoPlace = injector.get('autoPlace', false)
  }

  contextPad.registerProvider(this)
}

// function (element)
BpmnCustomContextPad.prototype.getContextPadEntries = function () {
  // const { autoPlace, create, elementFactory, translate } = this

  // console.log('Hello Here !')

  // function appendWaitTaskStart(event) {
  //   const shape = elementFactory.createBpmnElement('shape', {
  //     type: 'bpmn:IntermediateCatchEvent',
  //     eventDefinitionType: 'bpmn:TimerEventDefinition'
  //   })
  //   create.start(event, shape, element)
  // }

  // function appendWaitTask(event, el) {
  //   if (autoPlace) {
  //     const shape = elementFactory.createBpmnElement('shape', {
  //       type: 'bpmn:IntermediateCatchEvent',
  //       eventDefinitionType: 'bpmn:TimerEventDefinition'
  //     })
  //     autoPlace.append(el, shape)
  //   } else {
  //     appendWaitTaskStart(event, el)
  //   }
  // }

  return function (entries) {
    // entries['append.timer-intermediate-event'] = {
    //   group: 'model',
    //   className: 'bpmn-icon-intermediate-event-catch-timer',
    //   title: translate('Append Wait'),
    //   action: {
    //     click: appendWaitTask,
    //     dragstart: appendWaitTaskStart
    //   },
    //   eventDefinitionType: 'bpmn:TimerEventDefinition'
    // }
    delete entries['append.intermediate-event']
    delete entries['append.text-annotation']
    delete entries.replace

    return entries
  }
}

BpmnCustomContextPad.$inject = ['config', 'contextPad', 'create', 'elementFactory', 'injector', 'translate']
